/* Cloth-Vastr — Liquid Glass interactions: live deal pill, 3D coverflow, card "open" reveal, product 3D stage */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- Floating live pill ---------- */
  function livePill() {
    var el = document.getElementById('cv-live');
    if (!el) return;
    if (store('cv-live-off') === '1') { el.classList.add('is-hidden'); return; }
    setTimeout(function () { el.classList.add('is-in'); }, 1200);
    var msgs = el.querySelectorAll('.cv-live__msg'), i = 0;
    if (msgs.length > 1 && !reduce) {
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, 3400);
    }
    el.querySelector('.cv-live__x').addEventListener('click', function () {
      el.classList.remove('is-in');
      store('cv-live-off', '1');
      setTimeout(function () { el.classList.add('is-hidden'); }, 700);
    });
    var end = Date.parse(el.dataset.end || '');
    var t = el.querySelector('.cv-live__timer');
    if (end && t) {
      var tick = function () {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (!s) { t.hidden = true; return; }
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
        t.textContent = (d ? d + 'd ' : '') + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
        t.hidden = false;
      };
      tick(); setInterval(tick, 1000);
    }
  }

  /* ---------- 3D coverflow (hot deals) ---------- */
  function coverflows() {
    document.querySelectorAll('[data-cv-coverflow]').forEach(function (stage) {
      var cards = Array.prototype.slice.call(stage.querySelectorAll('.cv-cf'));
      var n = cards.length;
      if (!n) return;
      var dots = stage.querySelector('.cv-hd__dots');
      dots.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
      var dotEls = dots.querySelectorAll('i');
      var cur = Math.min(1, n - 1), timer = null, hovering = false;

      function layout() {
        var mobile = window.innerWidth < 990;
        var gap = mobile ? 150 : Math.min(230, stage.clientWidth / 4.2);
        cards.forEach(function (c, i) {
          var off = i - cur;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var a = Math.abs(off);
          var visible = a <= (mobile ? 1 : 2);
          var x = off * gap, z = -a * 180, ry = off * -32, s = 1 - a * 0.06;
          c.style.transform = 'translate3d(' + x + 'px,' + (a * 14) + 'px,' + z + 'px) rotateY(' + ry + 'deg) scale(' + s + ')';
          c.style.opacity = visible ? String(1 - a * 0.22) : '0';
          c.style.zIndex = String(100 - a);
          c.style.visibility = visible ? 'visible' : 'hidden';
          c.classList.toggle('is-center', off === 0);
          c.setAttribute('aria-hidden', off === 0 ? 'false' : 'true');
          var link = c.querySelector('.cv-cf__link');
          if (link) link.tabIndex = off === 0 ? 0 : -1;
        });
        dotEls.forEach(function (d, i) { d.classList.toggle('is-on', i === cur); });
      }
      function go(d) { cur = (cur + d + n) % n; layout(); }
      function auto() {
        clearInterval(timer);
        if (reduce) return;
        timer = setInterval(function () { if (!hovering && !document.hidden) go(1); }, 4200);
      }
      stage.querySelectorAll('.cv-hd__arrow').forEach(function (b) {
        b.addEventListener('click', function () { go(parseInt(b.dataset.dir, 10)); auto(); });
      });
      cards.forEach(function (c, i) {
        c.addEventListener('click', function (e) {
          if (!c.classList.contains('is-center')) {
            e.preventDefault();
            var off = i - cur; if (off > n / 2) off -= n; if (off < -n / 2) off += n;
            go(off); auto();
          }
        });
      });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(1); auto(); }
        if (e.key === 'ArrowLeft') { go(-1); auto(); }
      });
      stage.addEventListener('pointerenter', function () { hovering = true; });
      stage.addEventListener('pointerleave', function () { hovering = false; });
      stage.addEventListener('focusin', function () { hovering = true; });
      stage.addEventListener('focusout', function () { hovering = false; });
      var sx = null;
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
      stage.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); auto(); }
      });
      if (fine && !reduce) {
        stage.addEventListener('pointermove', function (e) {
          var c = stage.querySelector('.cv-cf.is-center .cv-cf__link');
          if (!c) return;
          var r = c.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { c.style.transform = ''; return; }
          var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
          c.style.transform = 'rotateY(' + px * 10 + 'deg) rotateX(' + -py * 10 + 'deg) translateZ(30px)';
        });
        stage.addEventListener('pointerleave', function () {
          var c = stage.querySelector('.cv-cf.is-center .cv-cf__link'); if (c) c.style.transform = '';
        });
      }
      window.addEventListener('resize', layout, { passive: true });
      layout(); auto();
    });
  }

  /* ---------- Product cards: second angle "opens" on hover ---------- */
  function cardOpen() {
    if (!fine || reduce) return;
    function bind(card) {
      if (card.dataset.cvOpen) return;
      var g = card.querySelector('.card-gallery');
      if (!g) return;
      var imgs = g.querySelectorAll('img.product-media__image');
      card.dataset.cvOpen = '1';
      if (imgs.length < 2) return;
      var src = imgs[1];
      var layer = document.createElement('div');
      layer.className = 'cv-open';
      layer.setAttribute('aria-hidden', 'true');
      var im = document.createElement('img');
      im.alt = '';
      im.loading = 'lazy';
      im.decoding = 'async';
      if (src.getAttribute('srcset')) im.srcset = src.getAttribute('srcset');
      im.sizes = src.getAttribute('sizes') || '(min-width: 990px) 25vw, 50vw';
      im.src = src.getAttribute('src');
      layer.appendChild(im);
      g.appendChild(layer);
    }
    function scan() { document.querySelectorAll('product-card').forEach(bind); }
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Product page: 3D media stage + live deal strip ---------- */
  function productStage() {
    var info = document.querySelector('.product-information');
    if (!info) return;

    var data = document.getElementById('cv-pdata');
    var price = info.querySelector('.product-details .price');
    if (price && !info.querySelector('.cv-dealstrip')) {
      var save = '';
      try {
        var d = JSON.parse(data.textContent);
        if (d.compare > d.price) save = 'Save ' + Math.round((1 - d.price / d.compare) * 100) + '% today';
      } catch (e) {}
      var strip = document.createElement('div');
      strip.className = 'cv-dealstrip';
      strip.innerHTML = '<span class="cv-dealstrip__live"><span class="cv-live-dot" aria-hidden="true"></span>Sale live</span>' +
        (save ? '<span class="cv-dealstrip__save">' + save + '</span>' : '') +
        '<span>Set of 3, pay for 2</span><span>Free shipping · USA &amp; Canada</span>';
      var anchor = price.closest('product-price') || price.parentElement;
      anchor.insertAdjacentElement('afterend', strip);
    }

    if (!fine || reduce) return;
    function bind(box) {
      if (box.dataset.cvStage) return;
      box.dataset.cvStage = '1';
      box.classList.add('cv-stage3d');
      var spec = document.createElement('span'); spec.className = 'cv-spec'; box.appendChild(spec);
      box.addEventListener('pointermove', function (e) {
        var r = box.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        box.style.transform = 'perspective(1400px) rotateY(' + (px - 0.5) * 7 + 'deg) rotateX(' + (0.5 - py) * 7 + 'deg)';
        box.style.setProperty('--sx', px * 100 + '%'); box.style.setProperty('--sy', py * 100 + '%');
      });
      box.addEventListener('pointerleave', function () { box.style.transform = ''; });
    }
    info.querySelectorAll('.product-information__media .product-media-container').forEach(bind);
  }

  ready(function () {
    try { livePill(); } catch (e) {}
    try { coverflows(); } catch (e) {}
    try { cardOpen(); } catch (e) {}
    try { productStage(); } catch (e) {}
  });
})();
